import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../data.service';
import { Trasllat } from '../lib/model/trasllat';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-confirmacio',
  templateUrl: './confirmacio.component.html',
  styleUrls: ['./confirmacio.component.css']
})
export class ConfirmacioComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  trasllat: Trasllat;

  constructor(
      private dataService: DataService,
  ) {
    this.trasllat = dataService.trasllat;
  }

  ngOnInit() {
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/confirmacio/confirmacio.component.ts